<template>
  <section class="hero-section">
    <div class="hero-section__content marketing-section__content--narrow">
      <h1 class="text-h3 text-sm-h2 font-weight-bold text-white mb-4">
        Say yes with confidence.
      </h1>
      <p class="text-body-1 text-sm-h6 font-weight-regular text-white mb-2">
        Threshold-funded RV events with transparent budgets, locked details, and
        organizer accountability. If enough people commit, it happens. If not,
        no one gets burned.
      </p>
      <p
        class="text-body-2 text-sm-body-1 mb-8"
        style="color: rgba(255, 255, 255, 0.8)"
      >
        Built with and for the community that organizes its own adventures.
      </p>
      <v-btn
        to="/browse"
        size="large"
        color="white"
        class="text-primary font-weight-bold"
      >
        Browse Events
      </v-btn>
    </div>
  </section>
</template>

<style scoped>
.hero-section {
  background:
    linear-gradient(
      135deg,
      rgba(0, 102, 134, 0.65),
      rgba(0, 77, 102, 0.7),
      rgba(0, 30, 43, 0.75)
    ),
    url('/hero-bg.jpg') center / cover no-repeat;
  padding: 6rem 1.5rem;
  min-height: 420px;
  display: flex;
  align-items: center;
}

.hero-section__content {
  width: 100%;
}
</style>
